import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import SideNavigation, { MOBILE_BAR_HEIGHT } from './SideNavigation';
import SupportModeDialog from './SupportModeDialog';

/**
 * Menu til venstre på computer, bag en knap i toppen på telefon.
 * Indholdet har samme bredde og afstande på alle sider.
 */
const Layout = ({ children }: { children: ReactNode }) => (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
        <SideNavigation />
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                minWidth: 0,                                   // så brede tabeller kan scrolle i stedet for at sprænge siden
                px: { xs: 2, md: 4 },
                py: { xs: 2, md: 4 },
                pt: { xs: `${MOBILE_BAR_HEIGHT + 16}px`, md: 4 },
            }}
        >
            <SupportModeDialog />
            <Box sx={{ maxWidth: 1240, mx: 'auto' }}>{children}</Box>
        </Box>
    </Box>
);

export default Layout;
